import React from 'react'

// mui
import { Box, Card, CardContent, Typography, Divider, Button } from '@mui/material';
import { Cloud } from '@mui/icons-material';

// i18next
import { useTranslation } from 'react-i18next';

// hooks
import { useEffect } from 'react';

// components
import Selection from './Selection';

export default function WeatherApp({ cityTemp, date, lang, setLang, setLat,setLon }) {

    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(lang);
    }, [lang, i18n])

    function handleLang() {
        setLang(lang === "ar" ? "en" : "ar");
    }

    return (
        <Box sx={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            alignItems: "flex-end",
            flexDirection: "column"
        }}>
            <Card sx={{
                minWidth: { xs: "200px", sm: "450px" },
                background: "#0a3e98",
                borderRadius: "10px"
            }}>
                <CardContent>
                    <Box sx={{
                        display: "flex",
                        gap: "10px",
                        alignItems: { xs: "center", sm: "flex-end" },
                        mb: 2,
                        flexDirection: { xs: "column", sm: "row" }
                    }}>
                        <Typography variant="h2" sx={{
                            color: 'white',
                            fontSize: { xs: "30px", sm: "60px",textAlign:"center" }
                        }}>
                            {cityTemp.city}
                        </Typography>
                        <Typography sx={{
                            color: "white",
                            fontSize: 14
                        }}>
                            {date}
                        </Typography>
                    </Box>

                    <Divider sx={{ background: "white" }} />

                    <Box sx={{
                        display: "flex",
                        gap: "25px",
                        justifyContent: "space-between",
                        flexDirection: { xs: "column-reverse", sm: "row" }
                    }}>
                        <Box>

                            <Box sx={{ display: "flex", gap: "10px", alignItems: "center", color: "white" }}>
                                <Typography variant="h2" color="white">{cityTemp.number}</Typography>
                                <img src={`https://openweathermap.org/img/wn/${cityTemp.icon}@2x.png`} alt="img"
                                    style={{ fontSize: "50px" }}>

                                </img>
                            </Box>

                            <Typography variant="h6" color="white">{cityTemp.details}</Typography>

                            <Box sx={{ display: "flex", gap: "5px", alignItems: "center", mt: 2 }}>
                                <Typography variant="p" color="white" sx={{ fontSize: "14px" }}>{t("الصغرى")}: {cityTemp.min}</Typography>
                                <span style={{
                                    color: "white",
                                    fontSize: "14px"
                                }}>|</span>
                                <Typography variant="p" color="white" sx={{ fontSize: "14px" }}>{t("الكبرى")}: {cityTemp.max}</Typography>
                            </Box>

                        </Box>
                        <Cloud sx={{
                            color: "white",
                            fontSize: "150px"
                        }} />
                    </Box>
                </CardContent>
            </Card>
            <Box sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "10px",
                flexDirection: { xs: "column", md: "row" },
            }}>
                <Button onClick={handleLang} variant="contained"
                    sx={{
                        color: "white",
                        background: "#0a3e98"
                    }}>{lang === "ar" ? "إنجليزي" : "Arabic"}
                </Button>
                <Selection lang={lang} setLat={setLat} setLon={setLon}/>
            </Box>
        </Box>
    )
}
